import type { FC, ReactNode } from "react";

import { cn } from "~/lib/utils";

const Typography: FC<{
  variant: "h1" | "h2" | "p" | "muted";
  textAlign?: "left" | "center" | "right" | "justify";
  className?: string;
  children: ReactNode;
}> = (props) => {
  const alignClass = props.textAlign ? `text-${props.textAlign}` : "";

  switch (props.variant) {
    case "h1":
      return (
        <h1
          className={cn(
            `backdrop-blur-xs text-4xl font-bold text-primary ${alignClass}`,
            props.className,
          )}
        >
          {props.children}
        </h1>
      );
    case "h2":
      return (
        <h2
          className={cn(
            `backdrop-blur-xs text-3xl font-semibold ${alignClass}`,
            props.className,
          )}
        >
          {props.children}
        </h2>
      );
    case "p":
      return (
        <p
          className={cn(
            `font-medium backdrop-blur-xs text-base ${alignClass}`,
            props.className,
          )}
        >
          {props.children}
        </p>
      );
    case "muted":
      return (
        <span
          className={cn(
            `font-medium text-muted-foreground backdrop-blur-xs text-base ${alignClass}`,
            props.className,
          )}
        >
          {props.children}
        </span>
      );
    default:
      return (
        <span className={cn(`backdrop-blur-xs ${alignClass}`, props.className)}>
          {props.children}
        </span>
      );
  }
};

export default Typography;
